import { formatURIComponent } from './utils'
import {useUserInfoStore} from '@/stores/userInfoStore'

export default (instance:string) => {
    const userInfoStore = useUserInfoStore()
    const userInfo = userInfoStore.info as any

    console.log("userInfo", userInfo)

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}`
    }
    return [{
        pageLayout: 'tabs',
        pageTitle: '我的华美云',
        icons: [
        { 
            name: '项目资料',
            img: '/icons/我的项目.svg',
            url:  makeUrl(`项目资料`),
            path: "我的"
        },
        { 
            name: '项目报告',
            img: '/icons/我的城市.svg',
            url: makeUrl(`项目报告`),
            path: "我的"
        },
        {
            name: '在建待建',
            img: '/icons/趋势分析.svg',
            background: 'black',
            url: makeUrl('/内容文件/华美/在建待建'),
            // url: makeUrl('/内容文件/华美/在建待建/在建待建.json'),
            path: "华美顾问/在建待建"
        },
        {
            name: '正在招标',
            img: '/icons/趋势分析.svg',
            background: 'black',
            url: makeUrl('/内容文件/华美/正在招标'),
            // url: makeUrl('/内容文件/华美/在建待建/在建待建.json'),
            path: "华美顾问/正在招标"
        },
        { 
            name: '关注酒店',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/hotel`),
            path: "我的"
        },
        { 
            name: '关注城市',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/city`),
            path: "我的"
        },
        { 
            name: '关注品牌',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/brand`),
            path: "我的"
        },
        { 
            name: '关注集团',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/group`),
            path: "我的"
        },
        { 
            name: '关注研报',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/favorite/file`),
            path: "我的"
        },
        { 
            name: '华美服务',
            img: '/icons/我的品牌.svg',
            url: makeUrl(`/内容文件/华美/华美简介`),
            path: "我的"
        },
        
    ]}]
}